import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { SciNav } from './SciNav';
import { PageBlocks } from './blocks';

const SLUG_ALIAS: Record<string, string> = { home: 'home', models: 'models', pricing: 'pricing' };

let siteConfigCache: { siteFooter: string } | null = null;
async function fetchSiteFooter(): Promise<string> {
  if (siteConfigCache) return siteConfigCache.siteFooter;
  try {
    const d = await fetch(api('/api/catalog/site-config')).then(r => r.json());
    siteConfigCache = d;
    return d.siteFooter || 'CXAI-FreeRouter · 免费模型目录服务';
  } catch {
    return 'CXAI-FreeRouter · 免费模型目录服务';
  }
}

/** 公开页面视图：由 site_pages 的 blocks 数据驱动渲染（与后台编辑器所见即所得） */
export function PageView({ slug }: { slug?: string }) {
  const params = useParams();
  const s = (slug || params.slug || 'home').toLowerCase();
  const [page, setPage] = useState<{ title: string; subtitle: string; blocks: any[] } | null>(null);
  const [notFound, setNotFound] = useState(false);
  const [footer, setFooter] = useState('CXAI-FreeRouter · 免费模型目录服务');

  useEffect(() => {
    setNotFound(false);
    setPage(null);
    fetch(api(`/api/catalog/pages/${s}`))
      .then(r => (r.ok ? r.json() : Promise.reject(new Error('not found'))))
      .then(d => {
        let blocks: any[] = [];
        try { blocks = Array.isArray(d.blocks) ? d.blocks : []; } catch { blocks = []; }
        setPage({ title: d.title, subtitle: d.subtitle || '', blocks });
      })
      .catch(() => setNotFound(true));
    fetchSiteFooter().then(setFooter);
  }, [s]);

  if (notFound) {
    return (
      <div className="min-h-screen">
        <SciNav />
        <div className="flex min-h-[60vh] flex-col items-center justify-center text-center px-6">
          <div className="hud-label mb-3">404 · PAGE NOT FOUND</div>
          <h1 className="font-display text-3xl font-bold mb-4">页面不存在</h1>
          <p className="text-[var(--ink-dim)] mb-8">该页面可能已被隐藏或删除</p>
          <a href="/" className="neon-btn px-8 py-3">返回首页</a>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen">
        <SciNav />
        <div className="flex min-h-[60vh] items-center justify-center">
          <div className="status-dot on !h-3 !w-3" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <SciNav />
      <main className="flex-1">
        <PageBlocks blocks={page.blocks} />
      </main>
      <footer className="border-t border-[var(--line)] py-10 text-center">
        <div className="hud-label mb-2">CXAI-FREEROUTER · FREE MODEL CATALOG</div>
        <p className="text-sm text-[var(--ink-dim)]/70">{footer}</p>
      </footer>
    </div>
  );
}
